import { render, staticRenderFns } from "./CiCountdown.vue?vue&type=template&id=ba4891d0&scoped=true"
import script from "./CiCountdown.vue?vue&type=script&lang=js"
export * from "./CiCountdown.vue?vue&type=script&lang=js"
import style0 from "./CiCountdown.vue?vue&type=style&index=0&id=ba4891d0&prod&lang=scss"
import style1 from "./CiCountdown.vue?vue&type=style&index=1&id=ba4891d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4891d0",
  null
  
)

export default component.exports